import Vue from 'vue'
import Vuex from 'vuex'

import messages from '@/common/lang';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    msg: messages,
    auth: false,
    user: localStorage.mjti_user != null ? JSON.parse(localStorage.mjti_user) : {},
    token: localStorage.mjti_code != null ? JSON.parse(localStorage.mjti_code) : null,
    refresh_token: localStorage.mjti_token != null ? JSON.parse(localStorage.mjti_token) : null,
    modulos: localStorage.mjti_modulos != null ? JSON.parse(localStorage.mjti_modulos) : null,
    error: null,
    tipo:localStorage.mjti_tipo != null ? JSON.parse(localStorage.mjti_tipo) : null,
    loading: false,
    loading_app:false,
    mensaje_app:'mensaje de la aplicacion'
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setRefreshToken(state, payload) {
      state.refresh_token = payload
    },
    setModulos(state, payload) {
      state.modulos = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setTipo(state,payload){
      state.tipo=payload
    },
    setLoadingApp(state,payload){
      state.loading_app=payload
    },
    setMensajeApp(state,payload){
      state.mensaje_app=payload
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.token !== null && state.token !== undefined
    },
    getToken(state) {
      return state.token
    }
  }
})
